<template>
  <a-modal
    :title="title"
    :visible="visible"
    :width="900"
    @ok="handleOk"
    @cancel="handleCancel"
    okText="确认"
    cancelText="取消"
  >
    <a-card style="width: 100%" :activeTabKey="noTitleKey" @tabChange="(key) => onTabChange(key, 'noTitleKey')">
      <div style="display: flex; justify-content: space-between">
        <!-- <a-input-search
        v-model="inputQuery"
        placeholder="请输入搜索内容"
        style="width: 200px; margin-bottom: 20px;"
        @search="onSearch"
        enterButton
      /> -->
        <a-form v-if="isShowSeq">
          <a-form-item label="请填写序号" :labelCol="labelCol" :wrapperCol="wrapperCol" required>
            <a-input-number style="margin-left: 20px" v-model="seq" :min="1" />
          </a-form-item>
        </a-form>
      </div>
      <a-table
        ref="table"
        size="default"
        :filterMultiple="true"
        :rowKey="(item) => item.id"
        :columns="columns"
        :dataSource="goodsList"
        :rowSelection="rowSelectionGoods"
        :scroll="{ y: 300 }"
        @change="handleTableChangeGoods"
        :loading="loading"
      >
        <span slot="image" slot-scope="val">
          <img :src="cdnImg(val)" class="thumbnail" />
        </span>
      </a-table>
    </a-card>
  </a-modal>
</template>

<script>
import { STable } from '@/components'
export default {
  name: 'GoodsListModle',
  components: {
    STable,
  },
  props: {
    matType: {
      type: String,
      default: 'radio',
    },
    isShowSeq: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      visible: false,
      title: '选择天数',
      inputQuery: '',
      noTitleKey: 'tab1',
      seq: '',
      labelCol: {
        xs: { span: 10 },
        sm: { span: 10 },
      },
      wrapperCol: {
        xs: { span: 10 },
        sm: { span: 10 },
      },
      columns: [
        {
          title: '天数',
          dataIndex: 'dredgeDay',
        },
      ],
      goodsPagination: {
        total: 0,
        current: 1,
        pageSize: 10,
        showSizeChanger: true,
        pageSizeOptions: ['5', '10', '15', '20'],
      },
      loading: true,
      goodsList: [],
      activityList: [],
      pageParam: {
        page: 1,
        size: 10,
      },
      productId: '',
      selectedRows: [],
      selectedGoodsRows: [],
      selectedActivityRows: [],
      radioSelectRows: [],
      selectKeys: [],
    }
  },
  computed: {
    rowSelectionGoods() {
      return {
        type: this.matType,
        onChange: this.onGoodsChangeVal,
        selectedRowKeys: this.selectKeys,
        getCheckboxProps: (record) => ({
          props: {
            disabled: record.name === 'Disabled User',
            name: record.name,
          },
        }),
      }
    },
    rowSelectionActivity() {
      return {
        type: this.matType,
        onChange: this.onActivityChangeVal,
        selectedRowKeys: this.selectKeys,
        getCheckboxProps: (record) => ({
          props: {
            disabled: record.name === 'Disabled User',
            name: record.name,
          },
        }),
      }
    },
  },
  methods: {
    handleTableChangeGoods(pagination) {
      this.goodsPagination.current = pagination.current
      this.goodsPagination.pageSize = pagination.pageSize
      this.pageParam.page = pagination.current
      this.pageParam.size = pagination.pageSize
      this.getGoodsList()
    },
    handleTableChangeActivity(pagination) {
      this.activityPagination.current = pagination.current
      this.activityPagination.pageSize = pagination.pageSize
      this.pageParam.page = pagination.current
      this.pageParam.size = pagination.pageSize
      this.getActivityList()
    },

    // 商品选中
    onGoodsChangeVal(selectedRowKeys, selectedRows) {
      this.selectKeys = selectedRowKeys
      if (this.matType === 'radio') {
        this.selectedRows = []
      }
      this.selectedGoodsRows = this.selectedGoodsRows.concat(selectedRows.concat(this.selectedActivityRows))
      this.radioSelectRows = selectedRows
    },
    // 活动选中
    onActivityChangeVal(selectedRowKeys, selectedRows) {
      this.selectKeys = selectedRowKeys
      if (this.matType === 'radio') {
        this.selectedRows = []
      }
      this.selectedActivityRows = this.selectedActivityRows.concat(selectedRows.concat(this.selectedGoodsRows))
      this.radioSelectRows = selectedRows
      // this.$forceUpdate()
    },
    // 显示/隐藏
    show() {
      this.visible = true
      this.getGoodsList()
    },
    // 提交
    handleOk() {
      this.visible = false
      if (!this.seq && this.isShowSeq) {
        this.$error({
          title: '错误',
          content: '请输入序号',
        })
        return false
      }
      this.radioSelectRows[0].seq = this.seq
      this.selectedRows =
        this.matType === 'radio'
          ? this.radioSelectRows
          : this.deteleObject(this.selectedActivityRows.concat(this.selectedGoodsRows))
      this.$emit('selectDayData', this.selectedRows)
      // 初始化
      this.inputQuery = ''
      this.pageParam.size = 10
      this.pageParam.page = 1
      this.noTitleKey = 'tab1'
      this.goodsPagination = {
        total: 0,
        current: 1,
        pageSize: 10,
        showSizeChanger: true,
        pageSizeOptions: ['5', '10', '15', '20'],
      }
      this.activityPagination = {
        total: 0,
        current: 1,
        pageSize: 10,
        showSizeChanger: true,
        pageSizeOptions: ['5', '10', '15', '20'],
      }
      this.seq = ''
      this.selectKeys = []
      this.selectedRows = []
      this.selectedActivityRows = []
      this.selectedGoodsRows = []
    },
    // 关闭
    handleCancel() {
      this.visible = false
      // 初始化
      this.productId = ''
      this.selectedRows = []
      this.inputQuery = ''
      this.pageParam.size = 10
      this.pageParam.page = 1
      this.noTitleKey = 'tab1'
      this.goodsPagination = {
        total: 0,
        current: 1,
        pageSize: 10,
        showSizeChanger: true,
        pageSizeOptions: ['5', '10', '15', '20'],
      }
      this.activityPagination = {
        total: 0,
        current: 1,
        pageSize: 10,
        showSizeChanger: true,
        pageSizeOptions: ['5', '10', '15', '20'],
      }
      this.selectKeys = []
      this.selectedRows = []
      this.selectedActivityRows = []
      this.selectedGoodsRows = []
    },
    // 商品与活动tab之间切换
    onTabChange(key, type) {
      if (key === 'tab2') {
        this.pageParam.size = this.activityPagination.pageSize
        this.activityPagination.current = 1
        this.inputQuery = ''
        this.pageParam.page = 1
        this.getActivityList()
      } else {
        this.pageParam.size = this.goodsPagination.pageSize
        this.goodsPagination.current = 1
        this.inputQuery = ''
        this.pageParam.page = 1
        this.getGoodsList()
      }
      this[type] = key
    },
    async getGoodsList() {
      this.loading = true
      const params = {
        name: this.inputQuery,
        current: this.pageParam.page,
        size: this.pageParam.size,
      }
      const res = await this.$http.get('/p/security/web/integralGood/getPVIPOrgList', { params })
      this.goodsList = res
      this.goodsPagination.pageSize = res.size
      this.goodsPagination.total = res.total
      this.loading = false
      this.$forceUpdate()
    },
    async getActivityList() {
      this.loading = true
      const params = {
        name: this.inputQuery,
        current: this.pageParam.page,
        size: this.pageParam.size,
      }
      const res = await this.$http.get('/p/security/web/integralGood/getPVIPOrgList', { params })
      this.activityList = res
      this.activityPagination.pageSize = res.size
      this.activityPagination.total = res.total
      this.loading = false
      this.$forceUpdate()
    },
    onSearch() {
      // if (this.noTitleKey === 'tab1') {
      this.pageParam.page = 1
      this.pageParam.size = 10
      this.getGoodsList()
      // } else {
      //   this.pageParam.page = 1
      //   this.pageParam.size = 10
      //   this.getActivityList()
      // }
    },
    // 去除数组中重复的对象
    deteleObject(obj) {
      const uniques = []
      const stringify = {}
      for (let i = 0; i < obj.length; i++) {
        const keys = Object.keys(obj[i])
        keys.sort(function (a, b) {
          return Number(a) - Number(b)
        })
        let str = ''
        for (let j = 0; j < keys.length; j++) {
          str += JSON.stringify(keys[j])
          str += JSON.stringify(obj[i][keys[j]])
        }
        if (!stringify.hasOwnProperty(str)) {
          uniques.push(obj[i])
          stringify[str] = true
        }
      }
      return uniques
    },
  },
}
</script>

<style lang="stylus" scoped>
.thumbnail {
  width: 50px;
  height: 50px;
}
</style>
